import React, { useCallback, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { BsArrowDown } from "react-icons/bs";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import TablePagination from "../../../components/UI/Table/TablePagination";
import ButtonPermission from "../../../components/UI/Button/ButtonPermission";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";
import { formatarData } from "../../../components/Formatters/DateTime";
import AutoInfracaoEspecialDetalhe from "./components/AutoInfracaoEspecialDetalhe";
import TelaAIEspecialInicial from "./components/TelaAIEspecialInicial";

const columns = [
  {
    name: "Nº Auto Infração",
    selector: "numeroAuto",
    center: true,
    sortable: true,
  },
  {
    name: "Tipo",
    selector: "tipoAutoInfracao",
    center: true,
    sortable: true,
  },
  {
    name: "Situação",
    selector: "situacaoAuto",
    center: true,
    sortable: true,
  },
  {
    name: "Data Lavratura",
    cell: (row) => (row.dtLavratura ? formatarData(row.dtLavratura, "dd/MM/yyyy") : null),
    center: true,
    sortable: true,
  },
  {
    name: "Multa Regulamentar",
    cell: (row) => row.multaRegulamentar.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
    center: true,
  },
];

const AutoInfracaoEspecial = ({ dadosOs }) => {
  const [rows, setRows] = useState([]);
  const [totalRows] = useState(0);
  const setPageSize = useState(25)[1];
  const setPageNumber = useState(1)[1];
  const { request: requestConsulta, data: dataConsulta, errors: errorConsulta, isLoading } = useApiClient();
  const [mostrarTela, setMostrarTela] = useState(false);
  const [dadosAutoInfracao, setDadosAutoInfracao] = useState([]);

  const handlePageChange = useCallback(
    (newPageNumber) => {
      setPageNumber(newPageNumber);
    },
    [setPageNumber],
  );

  const handlePerRowsChange = useCallback(
    (newPageSize) => {
      setPageSize(newPageSize);
      setPageNumber(1);
    },
    [setPageNumber, setPageSize],
  );

  useEffect(() => {
    const params = { sqAcaoFiscal: dadosOs.acaoFiscal };
    requestConsulta(apiRoutes.fiscalizacao.autoinfracao.consultaAutoInfracaoEsp, params);
  }, [requestConsulta, dadosOs.acaoFiscal]);

  useEffect(() => {
    if (dataConsulta && dataConsulta.result) {
      setRows(dataConsulta.result.map((item) => ({ ...item, dadosOs })));
      setDadosAutoInfracao(dataConsulta.result);
    }

    if (errorConsulta) {
      toast.error(errorConsulta.message);
    }
  }, [dataConsulta, errorConsulta, dadosOs]);

  const data = rows.map((item) => {
    let disabled = false;
    if (item.situacaoAuto === "Cancelado") {
      disabled = true;
    }
    return { ...item, disabled };
  });

  return (
    <div style={{ width: "100%" }}>
      {!mostrarTela && (!dadosAutoInfracao[0] || dadosAutoInfracao[0]?.sequencialAutoAberto === 0) && (
        <Row style={{ marginBottom: 20, textAlign: "right" }}>
          <Col>
            <ButtonPermission
              className="mr-0 btn btn-primary btn-sm btn-user"
              name="Novo Auto de Infração Especial"
              permission={funcionalidades.autoInfracaoEspecial.inserir}
              onClick={() => setMostrarTela(true)}
            />
          </Col>
        </Row>
      )}
      {(mostrarTela || dadosAutoInfracao[0]?.sequencialAutoAberto > 0) && (
        <TelaAIEspecialInicial
          dadosOs={dadosOs}
          sequencialAuto={dadosAutoInfracao[0]?.sequencialAutoAberto > 0 ? dadosAutoInfracao[0]?.sequencialAuto : 0}
          dadosAIEspecial={dadosAutoInfracao}
          siglaAtividade="AIE0"
        />
      )}{" "}
      {!mostrarTela && !dadosAutoInfracao[0]?.sequencialAutoAberto && (
        <Row>
          <Col>
            <DataTable
              noHeader
              keyField="numeroAuto"
              columns={columns}
              data={data}
              progressPending={isLoading}
              noDataComponent="Não há Auto de Infração Especial cadastrado."
              progressComponent={<TextSpinner />}
              // defaultSortFieldId={1}
              sortIcon={<BsArrowDown />}
              pagination
              paginationServer
              sortable
              paginationTotalRows={totalRows}
              selectableRows={false}
              pointerOnHover
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              paginationComponent={TablePagination}
              paginationPerPage={10}
              expandableRows
              expandableRowDisabled={(row) => row.disabled}
              expandableRowsComponent={(row) => AutoInfracaoEspecialDetalhe({ dadosOs, row })}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col />
      </Row>
    </div>
  );
};

export default AutoInfracaoEspecial;
